import { render } from "./addWorkoutButton.vue?vue&type=template&id=2f656872&scoped=true"
import script from "./addWorkoutButton.vue?vue&type=script&lang=js"
export * from "./addWorkoutButton.vue?vue&type=script&lang=js"

import "./addWorkoutButton.vue?vue&type=style&index=0&id=2f656872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f656872"]])

export default __exports__